import { Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Week from "./Week";
import "./scheduler.css";
import moment from "moment";
const weekHeight = 150;
const days = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];

export default function Scheduler() {
  const scrollRef = useRef();
  const [offset, setOffset] = useState(-1);

  const isDragging = useSelector((state) => state.general.currentlyDragging);
  const [lockedPos, setLockedPos] = useState(weekHeight + 1);
  // useEffect(() => {
  // if (isDragging && scrollRef.current) {
  //   setLockedPos(scrollRef.current.scrollTop);
  //   console.log(scrollRef.current.scrollTop);
  // } else {
  //   setLockedPos(null);
  // }
  // }, [isDragging, scrollRef.current]);

  const onScroll = () => {
    // if (lockedPos) {
    //   scrollRef.current.scrollTo(0, lockedPos);
    //   return;
    // }
    const currentPos = scrollRef.current.scrollTop;
    setLockedPos(currentPos);
    // console.log(scrollRef.current.scrollTop, scrollRef.current.clientHeight);
    if (currentPos < weekHeight) {
      //add week above

      scrollRef.current.scrollTo(
        0,
        currentPos + scrollRef.current.children[0].clientHeight
      );
      setOffset(offset - 1);
    }
    if (currentPos > 7 * weekHeight - scrollRef.current.clientHeight) {
      scrollRef.current.scrollTo(
        0,
        currentPos - scrollRef.current.children[1].clientHeight
      );

      setOffset(offset + 1);
    }
  };
  useEffect(() => {
    scrollRef.current.scrollTo(0, weekHeight + 1);
  }, []);

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexFlow: "column",
      }}
    >
      <div style={{ height: "70px" }}>
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => {
              setOffset(-1);
              scrollRef.current.scrollTo(0, weekHeight + 1);
            }}
          >
            Today
          </Button>
          <div style={{ fontSize: "30px" }}>
            {moment()
              .startOf("week")
              .add(offset + 2, "weeks")
              .format("MMMM YYYY")}
          </div>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          {days.map((d) => (
            <td
              style={{
                width: `${100 / 7}%`,
                textAlign: "center",
                fontSize: "22px",
              }}
            >
              {d}
            </td>
          ))}
        </div>
      </div>
      <div
        style={{
          width: "100%",
          position: "relative",
          flexGrow: 1,
          overflow: "hidden",
        }}
      >
        <div
          className="infinite-scroll"
          ref={scrollRef}
          onScroll={onScroll}
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            top: isDragging ? -lockedPos : 0,
            ...(isDragging ? {} : { overflowY: "scroll" }),
          }}
        >
          {[...new Array(8)].map((_, i) => (
            <Week offset={i + offset} height={weekHeight} />
          ))}
        </div>
      </div>
    </div>
  );
}
